import { gql } from '@apollo/client';

export const getHomeBannerData = gql`
query getHomeBanner {
    getHomeBanner {
        id
        name
    }
}
`;

export const getHomePageData = gql`
query getHomeData {
  getHomeData {
    result {
      id
      title
      content
      isEnable
      getHomeBanner {
        id
        name
        enable
      }
      getImageBanner {
        id
        title
        description
        buttonLabel
        image
      }
      getPopularLocationAdmin {
        id
        location
        locationAddress
        image
        isEnable
        createdAt
        updatedAt
      }
      getStaticInfo {
        title
        content
        name
        image
        isEnable
      }
      getRecommend {
        id
        title
        city
        state
        beds
        bookingType
        coverPhoto
        reviewsCount
        reviewsStarRating
        listPhotos {
          id
          name
          type
          status
        }
        user {
          id
          userBanStatus
        }
        listingData {
          basePrice
          currency
        }
        settingsData {
          listsettings {
            id
            itemName
          }
        }
        wishListStatus
        isListOwner
      }
      getMostViewedListing {
        id
        title
        city
        state
        beds
        bookingType
        coverPhoto
        reviewsCount
        reviewsStarRating
        listPhotos {
          id
          name
          type
          status
        }
        user {
          id
          userBanStatus
        }
        listingData {
          basePrice
          currency
        }
        settingsData {
          listsettings {
            id
            itemName
          }
        }
        wishListStatus
        isListOwner
      }
    }
  }
}
`;

export const getImageBannerData = gql`
query getImageBanner {
    getImageBanner {
        id
        title
        description
        buttonLabel
        image
    }
}
`;

export const GetMostViewedListing = gql`
query GetMostViewedListing {
  GetMostViewedListing {
    id
    title
    city
    state
    personCapacity
    beds
    bookingType
    coverPhoto
    reviewsCount,
    reviewsStarRating,
    listPhotos {
      id
      name
      type
      status
    }
    user {
      id
      userBanStatus
    }
    listingData {
      basePrice
      currency
    }
    settingsData {
      listsettings {
        id
        itemName
      }
    }
    wishListStatus
    isListOwner
  }
}
`;

export const getPopularLocationAdmin = gql`
query getPopularLocationAdmin {
  getPopularLocationAdmin{
    id
    location
    locationAddress
    image
    isEnable
    createdAt
    updatedAt
  }
}
`;

export const getRecommend = gql`
query getRecommend {
  getRecommend {
    id
    title
    city
    state
    personCapacity
    beds
    bookingType
    coverPhoto
    reviewsCount,
    reviewsStarRating,
    listPhotos {
      id
      name
      type
      status
    }
    user {
      id
      userBanStatus
    }
    listingData {
      basePrice
      currency
    }
    settingsData {
      listsettings {
        id
        itemName
      }
    }
    wishListStatus
    isListOwner
  }
}
`;

export const getPopularNearby = gql`
query getPopularNearby($lat: Float, $lng: Float) {
  getPopularNearby(lat: $lat, lng: $lng) {
    id
    title
    city
    state
    personCapacity
    beds
    bookingType
    coverPhoto
    reviewsCount,
    reviewsStarRating,
    listPhotos {
      id
      name
      type
      status
    }
    user {
      id
      userBanStatus
    }
    listingData {
      basePrice
      currency
    }
    settingsData {
      listsettings {
        id
        itemName
      }
    }
    wishListStatus
    isListOwner
  }
}
`;

export const getUserLocationName = gql`
query getUserLocationName($lat: Float, $lng: Float) {
  getUserLocationName(lat: $lat, lng: $lng)
}
`;

export const getStayInCity = gql`
  query getStayInCity {
    getStayInCity {
      cityName
      listings {
        id
        title
        city
        state
        personCapacity
        beds
        bookingType
        coverPhoto
        reviewsCount
        reviewsStarRating
        listPhotos {
          id
          name
          type
          status
        }
        user {
          id
          userBanStatus
        }
        listingData {
          basePrice
          currency
        }
        settingsData {
          listsettings {
            id
            itemName
          }
        }
        wishListStatus
        isListOwner
      }
    }
  }
`;

export const getStaticInfoData = gql`
query getStaticInfo {
  getStaticInfo {
        title
        content
        name
        image
        isEnable
      }
}
`;
